import { render, staticRenderFns } from "./FormHosSelect.vue?vue&type=template&id=66bed769&scoped=true&"
import script from "./FormHosSelect.vue?vue&type=script&lang=js&"
export * from "./FormHosSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormHosSelect.vue?vue&type=style&index=0&id=66bed769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bed769",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bed769')) {
      api.createRecord('66bed769', component.options)
    } else {
      api.reload('66bed769', component.options)
    }
    module.hot.accept("./FormHosSelect.vue?vue&type=template&id=66bed769&scoped=true&", function () {
      api.rerender('66bed769', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormHosSelect.vue"
export default component.exports